import { defineNuxtRouteMiddleware } from '#imports'

export default defineNuxtRouteMiddleware((to, from) => {
	if (import.meta.server) return
	if (to.path === from.path) return
	const { segmentPageView } = useSegment()

	segmentPageView(to.path, to.fullPath)
})
